import { Component } from '@angular/core';

@Component({
    standalone: false,
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
})
export class SearchBoxComponent {
    constructor() {}
}
